import System from './System'

export default System
